export const footer = {
  copyright: "Copyright",
  faq: "FAQ",
  contact_us: "Contactez-nous",
  tos: "Conditions d'utilisation",
  video_policy: "Politiques vidéo",
  privacy_policy: "Politiques de confidentialité",
  back_to_top: "RETOUR EN HAUT",
};
